import { CompleteActivitySummaryData } from "../complete-activity-summary/complete-activity-summary-data";

export class CompleteActivityInstallSignatureData {
    summary: CompleteActivitySummaryData;
    merchantMember: string;
    merchantEmail: string;
}